export function formatDate(value?: string | null) {
  return value?.slice(0, 10) || '-';
}

export function formatSize(size?: number | null) {
  if (size == null) return '';
  if (size < 1024) return `${size}B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)}KB`;
  return `${(size / (1024 * 1024)).toFixed(1)}MB`;
}

export type PreviewAttachment = {
  attachmentId: number;
  fileName: string;
  fileSize?: number | null;
};

export function PreviewAttachmentList({
  files,
  onDownload,
}: {
  files?: PreviewAttachment[] | null;
  onDownload: (file: PreviewAttachment) => void;
}) {
  const list = files ?? [];
  return (
    <ul className="edu-plan-files">
      {list.map((file) => (
        <li key={file.attachmentId}>
          <div>
            <strong>{file.fileName}</strong>
            <span>{formatSize(file.fileSize)}</span>
          </div>
          <div className="edu-plan-files__actions">
            <button
              type="button"
              className="ncr-btn is-secondary"
              onClick={() => onDownload(file)}
            >
              다운로드
            </button>
          </div>
        </li>
      ))}
      {list.length === 0 ? <li className="is-empty">등록된 첨부파일이 없습니다.</li> : null}
    </ul>
  );
}
